module.exports = __webpack_public_path__ + "static/desktop-footer-age-7d102766359fa0e6769345a437657bcf.jpg";